import {ERROR_DESC} from '../const/error';

export const getRussianErrorMessage = (originalMessage: string): string => {
  const englishMessage = originalMessage.replace(/[.,:;?!-]/g, '');

  const russianMessage = ERROR_DESC[englishMessage];

  return russianMessage ? russianMessage : 'Неизвестная ошибка, попробуйте снова';
}
